import React, { useEffect, useState } from 'react'
import Select from 'react-select';

import axios from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import { PhotoIcon, UserCircleIcon } from '@heroicons/react/24/solid'
import { ChevronDownIcon } from '@heroicons/react/16/solid';

const LoanCreate = ({ close }) => {
  const [loading, setLoading] = useState(true)
  const [formData, setFormData] = useState({
    finance_customer_id: "",
    loan_amount: "",
    interest_rate: "",
    interest_type: "interest_only",
    loan_start_date: "",
    loan_terms_months: "",
    calculation_day: "",
  });

  const navigate = useNavigate();
  const [validation, setvalidation] = useState([])
  const [error, setError] = useState(null)
  const [financeCustomer, setFinanceCustomer] = useState([])


  const fetchData = async () => {
    try {
      setLoading(true)
      const token = localStorage.getItem("token");
      const response = await axios.get(`public/api/finance-customers/list`, {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        }
      })
      setFinanceCustomer(response.data)

    } catch (error) {
      if (error.response && error.response.status === 401) {
        localStorage.removeItem("token");
        navigate("/crm");
      }
    }
  }

  useEffect(() => {
    fetchData()
  }, [])
  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }))

  }

  const handleChangeData = (selectedOption) => {
    setFormData((prev) => ({
      ...prev,
      finance_customer_id: selectedOption ? selectedOption.value : null,
    }));
  };
  const options = financeCustomer.map((item) => ({
    label: item.name,
    value: item.id,   // better to use ID instead of name
  }));
  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const token = localStorage.getItem("token");
      const response = await axios.post(`public/api/loans`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });

      if (response.data) {
        toast.success(response?.data.message);
        close();
      }
    } catch (error) {

      if (error.response && error.response.status === 401) {
        localStorage.removeItem("token");
        navigate("/crm");
      }
      setvalidation(error?.response);
    }
  }

  if (error) {
    return (
      <div className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-50 z-50">
        <div className="bg-white rounded-lg shadow-lg p-8 max-w-md">
          <div className="flex items-center justify-center mb-6">
            <svg
              className="h-12 w-12 text-red-500"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
          </div>

          <p className="text-gray-600 mb-8 text-center">
            Please check your internet connection and try again.
          </p>
          <div className="flex justify-center">
            <button
              className="bg-[#0f172a] hover:bg-teal-900 text-white font-semibold py-2 px-4 rounded transition duration-300"
              onClick={fetch}
            >
              Try Again
            </button>
          </div>
        </div>
      </div>
    )

  }
  return (
    <div className='p-6'>
      <div className="flex items-center justify-end  w-full">
        <button
          onClick={close}
          className="text-gray-500 hover:text-gray-700 focus:outline-none"
        >
          <svg
            className="w-6 h-6"
            fill="none"
            stroke="black"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M6 18L18 6M6 6l12 12"
            ></path>
          </svg>
        </button>
      </div>
      <div className='flex flex-col items-center mt-6  '>
        <div className="bg-blue-500 text-white p-3  rounded-full">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="40" height="40" color="#000000" fill="none">
            <path d="M18.5 20V17.9704C18.5 16.7281 17.9407 15.5099 16.8103 14.9946C15.4315 14.3661 13.7779 14 12 14C10.2221 14 8.5685 14.3661 7.18968 14.9946C6.05927 15.5099 5.5 16.7281 5.5 17.9704V20" stroke="#ffffff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
            <circle cx="12" cy="7.5" r="3.5" stroke="#ffffff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></circle>
          </svg>
        </div>
        <h1 className='text-3xl font-bold mt-4'>Add New Loan</h1>

        <p className="text-gray-600 mt-2 text-center">
          Complete the form below to add a new Loan to your chit fund.
          All fields marked with <span className="text-red-500">*</span> are required.
        </p>
      </div>
      <div className=' border-b-2 mt-4 '></div>
      <form onSubmit={handleSubmit}>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 mt-4 gap-6">

          <div>
            <label htmlFor="name" className="block text-sm font-medium text-gray-700 flex items-center gap-2">
              <span className='border bg-blue-100 rounded-full p-1'>

                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16" color="#bd10e0" fill="none">
                  <path d="M18.5 20V17.9704C18.5 16.7281 17.9407 15.5099 16.8103 14.9946C15.4315 14.3661 13.7779 14 12 14C10.2221 14 8.5685 14.3661 7.18968 14.9946C6.05927 15.5099 5.5 16.7281 5.5 17.9704V20" stroke="#bd10e0" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                  <circle cx="12" cy="7.5" r="3.5" stroke="#bd10e0" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></circle>
                </svg>
              </span> Name  <span className='text-lg'> *</span>
            </label>

            <div className="mt-2">
              <Select
                label="Customer Name"
                name="finance_customer_id"
                options={options}
                onChange={handleChangeData}
                value={options.find(
                  (opt) => opt.value === formData?.finance_customer_id
                )}
                isSearchable
                isClearable={true}
              />
            </div>
            <p className="text-red-600 text-sm mt-1">{validation?.errors?.finance_customer_id}</p>
          </div>

          <div>
            <label htmlFor="loan_amount"
              className="block text-sm font-medium text-gray-700 flex items-center gap-2"
            >

              <span className='border bg-red-100 rounded-full p-1'>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  width="14"
                  height="14"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M3 7h18v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7z" />
                  <path d="M16 11h2" />
                </svg>


              </span>
              Loan Amount  {""}
              <span className='text-lg'> *</span>
            </label>
            <input
              id="loan_amount"
              name="loan_amount"
              type="number"
              placeholder="Enter Loan Amount"
              value={formData?.loan_amount}
              onChange={handleChange}
              className="mt-2 block w-full rounded-md border-gray-300 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
            />
            <p className="text-red-600 text-sm mt-1">{validation?.errors?.loan_amount}</p>
          </div>

          <div>
            <label htmlFor="interest_rate"
              className="block text-sm font-medium text-gray-700 flex items-center gap-2"
            >

              <span className='border bg-red-100 rounded-full p-1'>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  width="14"
                  height="14"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <line x1="19" y1="5" x2="5" y2="19" />
                  <circle cx="6.5" cy="6.5" r="2.5" />
                  <circle cx="17.5" cy="17.5" r="2.5" />
                </svg>

              </span>
              Interest Rate  {""}
              <span className='text-lg'> *</span>
            </label>
            <input
              id="interest_rate"
              name="interest_rate"
              type="number"
              placeholder="Enter Interest Rate"
              value={formData?.interest_rate}
              onChange={handleChange}
              className="mt-2 block w-full rounded-md border-gray-300 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
            />
            <p className="text-red-600 text-sm mt-1">{validation?.errors?.interest_rate}</p>
          </div>

          <div>
            <label htmlFor="interest_type"
              className="block text-sm font-medium text-gray-700 flex items-center gap-2"
            >

              <span className='border bg-red-100 rounded-full p-1'>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  width="14"
                  height="14"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <rect x="5" y="3" width="14" height="18" rx="2" />
                  <path d="M9 7h6" />
                  <path d="M9 11h.01" />
                  <path d="M12 11h.01" />
                  <path d="M15 11h.01" />
                  <path d="M9 15h.01" />
                  <path d="M12 15h.01" />
                  <path d="M15 15h.01" />
                </svg>


              </span>
              Interest Type  {""}
              <span className='text-lg'> *</span>
            </label>
            {/* <input
              id="interest_type"
              name="interest_type"
              type="text"
              placeholder="Enter Interest Rate"
              value={formData?.interest_type}
              onChange={handleChange}
              className="mt-2 block w-full rounded-md border-gray-300 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
            /> */}

            <select
              id="interest_type"
              name="interest_type"
              value={formData.interest_type}
              onChange={handleChange}
              autoComplete="interest_type"
              className="block mt-2 w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
            >
              <option >Select Instrest Type</option>
              <option value="interest_only" >Interest Only</option>
              <option value="flat">Flat</option>
              <option value="reducing" >Reducing</option>

            </select>
            <p className="text-red-600 text-sm mt-1">{validation?.errors?.interest_type}</p>
          </div>

          <div>
            <label htmlFor="loan_start_date"
              className="block text-sm font-medium text-gray-700 flex items-center gap-2"
            >

              <span className='border bg-red-100 rounded-full p-1'>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  width="14"
                  height="14"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
                  <line x1="16" y1="2" x2="16" y2="6" />
                  <line x1="8" y1="2" x2="8" y2="6" />
                  <line x1="3" y1="10" x2="21" y2="10" />
                </svg>

              </span>
              Loan  Start Date   {""}
              <span className='text-lg'> *</span>
            </label>
            <input
              id="loan_start_date"
              name="loan_start_date"
              type="date"
              placeholder="Enter loan date"
              value={formData?.loan_start_date}
              onChange={handleChange}
              className="mt-2 block w-full rounded-md border-gray-300 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
            />
            <p className="text-red-600 text-sm mt-1">{validation?.errors?.loan_start_date}</p>
          </div>

          {/* <div>
            <label htmlFor="loan_terms_months"
              className="block text-sm font-medium text-gray-700 flex items-center gap-2"
            >

              <span className='border bg-red-100 rounded-full p-1'>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  width="14"
                  height="14"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <circle cx="12" cy="12" r="9" />
                  <path d="M12 7v5l3 3" />
                </svg>

              </span>
              Loan  Term  Month   {""}
              <span className='text-lg'> *</span>
            </label>
            <input
              id="loan_terms_months"
              name="loan_terms_months"
              type="number"
              placeholder="Enter loan date"
              value={formData?.loan_terms_months}
              onChange={handleChange}
              className="mt-2 block w-full rounded-md border-gray-300 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
            />
            <p className="text-red-600 text-sm mt-1">{validation?.errors?.loan_terms_months}</p>
          </div> */}

          <div>
            <label htmlFor="calculation_day"
              className="block text-sm font-medium text-gray-700 flex items-center gap-2"
            >

              <span className='border bg-red-100 rounded-full p-1'>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  width="14"
                  height="14"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <rect x="3" y="4" width="18" height="18" rx="2" />
                  <path d="M8 2v4M16 2v4" />
                  <circle cx="12" cy="15" r="2" />
                </svg>

              </span>
              Calculation Day  {""}
              <span className='text-lg'> *</span>
            </label>
            {/* <input
              id="calculation_day"
              name="calculation_day"
              type="number"
              placeholder="Enter Day"
              value={formData?.calculation_day}
              onChange={handleChange}
              className="mt-2 block w-full rounded-md border-gray-300 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
            /> */}

            <select
              id="calculation_day"
              name="calculation_day"
              value={formData.calculation_day}
              onChange={handleChange}
              className="block mt-2 w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
            >
              <option value="" disabled>
                Select Calculation Day
              </option>

              {[...Array(28)].map((_, index) => {
                const day = index + 1;
                return (
                  <option key={day} value={day}>
                    {day}
                  </option>
                );
              })}
            </select>

            <p className="text-red-600 text-sm mt-1">{validation?.errors?.calculation_day}</p>
          </div>
        </div>
        <div className="mt-6 text-right">
          <button
            type="submit"
            className="inline-flex items-center gap-2 px-6 py-2 bg-[#0f172a] text-white text-sm font-medium rounded-md shadow hover:bg-teal-900 transition-all"
          >
            Save
          </button>
        </div>
      </form>

    </div>
  )
}

export default LoanCreate
